import { Image } from "@aws-amplify/ui-react";

export default function RentujemyComLogo() {
  return (
    <Image src="/rentujemycom.png" alt="Rentujemy.com" width={200}></Image>
  );
}
